import React, { useState, useEffect, forwardRef } from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import Card from 'react-bootstrap/Card';
import Loading from "../../components/Loading";
import {MdCreditScore, MdCreditCard} from 'react-icons/md';
import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Button, CardActions, IconButton } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import api from '../../services/api';
import LoadingButton from '@mui/lab/LoadingButton';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Divider from '@mui/material/Divider';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import icon from '../../image/faturaIconGreen.svg'
import { getToken } from '../../services/auth';
import { useTheme } from '@mui/material/styles';
import {logNavegacao} from '../../function'
import HeaderBody from '../../components/HeaderBody';

function Faturas({setShowFaturas, user}) {
    const theme = useTheme();
    let initialized = false
    let idContrato = user.idContrato;
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    useEffect(() => {
        setPage(1);
        const getPayments = async (contrato) => {
            setLoading(true)
            setPage(0);
            let token = await getToken();
            api.get(`/clients/payments`,{
                params: {
                    token,
                    page: 0,
                    contrato,
                    limit: 10,
                }
            }).then(function (response) {
                let {data, status} = response.data;
                if(status === true){
                    if(data != null){
                        setList(data)
                    }else{
                        setList([])
                    }
                }
                // eslint-disable-next-line react-hooks/exhaustive-deps
                initialized = false;
                setLoading(false)
            }).catch(function(error){
                console.log(error)
                setLoading(false)
                // eslint-disable-next-line react-hooks/exhaustive-deps
                initialized = false;
            });
        }
        if(idContrato !== 0 && idContrato != null && idContrato !== undefined){
            if (!initialized) {
                initialized = true;
                getPayments(idContrato);
            }
        }
    }, [idContrato]);
    const [ page, setPage ] = useState(1);
    const [loadingBt, setLoadingBt] = useState(false);
    const loadMore = async (contrato) => {
        setLoadingBt(true)
        let token = await getToken();
        api.get(`/clients/payments`,{
            params: {
                token,
                page,
                contrato,
                limit: 10,
            }
        }).then(function (response) {
            let {data, status} = response.data;
            if(status === true){
                if(data != null){
                    setList(oldList => [...oldList, ...data]);
                }
            }
            setLoadingBt(false)
            setPage(page + 1);
        }).catch(function(error){
            console.log(error)
            setLoadingBt(false)
        });
    }
    const open = (url) => {
        window.open(url, '_blank', 'noreferrer');
    }
    const openAgrupado = (emissao, id_contrato) => {
        let emissaoFormat = emissao.split('/').reverse().join('-');
        window.open('https://greenium.com.br/admin/painel2.php?execute=suporte/faturamento/extrato-cliente-total-pdf-agrupado&contratoId='+id_contrato+'&dataExtrato=' + emissaoFormat, '_blank', 'noreferrer');
    }
    const [height, setWidth] = useState(0);
    useEffect(() => {
        const element = document.getElementById('home');
        if (element) {
          setWidth(element.getBoundingClientRect().height - 260); // or height
        }
    }, []);
    const copiar = (codigo) => {
        navigator.clipboard.writeText(codigo)
        setAlerta(true)
    }
    const [showBoleto, setShowBoleto] = useState(0);
    const openBoleto = (id) => {
        if(id === showBoleto){
            setShowBoleto(0);
        }else{
            setShowBoleto(id);
        }
    }
    const renderFaturas = (element, idx) => {
        let {id, vencimento, status, valor, formpagbanco, linkNota, linkBoleto, extrato, codigo_barras, agrupado, contrato_principal, emissao, chave_acesso} = element;
        valor = valor.toLocaleString('pt-br',{   
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
        return (
            <div key={idx} className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" style={{marginBottom: 20, marginTop: 20}}>
                <Paper elevation={12}>
                    <CardContent>
                        <Stack direction="row" spacing={2}>
                            {status !== "Em Aberto" ? (
                                <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                    <MdCreditScore color={"var(--main-white-color)"} size={30} />
                                </Avatar>
                            ) : (
                                <Avatar sx={{ backgroundColor: 'transparent', width: 50, height: 50 }} >
                                    <MdCreditCard color={"#a3a3a3"} size={30} />
                                </Avatar>
                            )}
                            <Stack direction="column" spacing={0}>
                                <Typography gutterBottom variant="body2" component="div">
                                    Vencimento: {vencimento}
                                </Typography>
                                <Typography gutterBottom variant="body2" component="div">
                                    Status: {status}
                                </Typography>
                            </Stack>
                        </Stack>
                        <Typography variant="body2" style={{marginTop: 10}}>
                            Valor:  R$ {valor}
                        </Typography>
                        {chave_acesso && (
                            <Typography variant="body2" style={{marginTop: 10}}>
                                Chave de Acesso: {chave_acesso}
                                <IconButton variant="contained" 
                                size="small" 
                                style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25, marginLeft: 10}}  
                                aria-label="Notificações" 
                                onClick={() => {
                                    copiar(chave_acesso);
                                    logNavegacao('Navegacao', `Copiado chave de acesso da nota boletoId: ${id}`);
                                }}>
                                    <ContentCopyIcon sx={{ color: "var(--main-white-color)"}} />
                                </IconButton>
                            </Typography>
                        )}
                        <Typography variant="caption" color="text.secondary">
                            {formpagbanco}
                        </Typography>
                    </CardContent>
                    <CardActions style={{justifyContent: 'space-around', paddingBottom: 16}}>
                        {status === "Em Aberto" ? (
                            <Button variant="contained" 
                            style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                            size="small" 
                            startIcon={showBoleto === id ? ( <BsChevronUp /> ) : (<BsChevronDown />)}
                            onClick={() => openBoleto(id)}>
                                Boleto
                            </Button>
                        ) : (
                            <Button variant="contained" 
                            style={{backgroundColor: '#a3a3a3', borderRadius: 25}} 
                            size="small" 
                            disabled={true}
                            startIcon={showBoleto === id ? ( <BsChevronUp /> ) : (<BsChevronDown />)}
                            >
                                Boleto
                            </Button>
                        )}
                        {linkNota == null ? (
                            <Button 
                                variant="contained" 
                                style={{backgroundColor: '#a3a3a3', borderRadius: 25}} 
                                size="small" 
                                startIcon={<AiOutlineDownload />}
                                disabled={true} 
                                >
                                NF
                            </Button>
                        ) : (
                            <Button 
                                variant="contained" 
                                style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                                size="small" 
                                startIcon={<AiOutlineDownload />}
                                disabled={linkNota == null ? true : false} 
                                onClick={() => {
                                    open(linkNota);
                                    logNavegacao('Navegacao', `NFS boletoId: ${id}`);
                                }}
                                >
                                NF
                            </Button>
                        )}
                        {extrato == null ? (
                            <Button 
                                variant="contained" 
                                style={{backgroundColor: '#a3a3a3', borderRadius: 25}} 
                                size="small" 
                                startIcon={<AiOutlineDownload />}
                                disabled={true} 
                                >
                                Extrato
                            </Button>
                        ) : (
                            <Button 
                                variant="contained" 
                                style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                                size="small" 
                                startIcon={<AiOutlineDownload />}
                                disabled={extrato == null ? true : false} 
                                onClick={() => {
                                    open(extrato);
                                    logNavegacao('Navegacao', `Extrado boletoId: ${id}`);
                                }}
                            >
                             Extrato
                            </Button>
                        )}
                        {agrupado && (
                            contrato_principal && (
                                <Button 
                                variant="contained" 
                                style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                                size="small" 
                                startIcon={<AiOutlineDownload />}
                                disabled={extrato == null ? true : false} 
                                onClick={() => {
                                    openAgrupado(emissao, idContrato);
                                    logNavegacao('Navegacao', `Extrado boletoId: ${id}`);
                                }}
                            >
                             Extrato Agrupado
                            </Button>
                            )
                        )}
                    </CardActions>
                        <List style={showBoleto === id ? {display: 'block'} : {display: 'none'}}>
                            <Divider />
                            {/* <ListItem disablePadding>
                                <ListItemButton onClick={() =>  {
                                    copiar(codigo_barras);
                                    logNavegacao('Navegacao', `Copiado codigo de barra boletoId: ${id}`);
                                }}>
                                    <ListItemIcon>
                                        <ContentCopyIcon />
                                    </ListItemIcon>
                                 <ListItemText primary="Pix" />
                                </ListItemButton>
                            </ListItem> */}
                            <ListItem disablePadding>
                                <ListItemButton onClick={() =>  {
                                    copiar(codigo_barras);
                                    logNavegacao('Navegacao', `Copiado codigo de barra boletoId: ${id}`);
                                }}>
                                    <ListItemIcon>
                                        <ContentCopyIcon />
                                    </ListItemIcon>
                                 <ListItemText primary="Copiar código de barra" />
                                </ListItemButton>
                            </ListItem>
                            <Divider />
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => {
                                    open(linkBoleto);
                                    logNavegacao('Navegacao', `Baixado boleto boletoId: ${id}`);
                                }}>
                                    <ListItemIcon>
                                        <FileDownloadIcon />
                                    </ListItemIcon>
                                    <ListItemText primary="Baixar boleto" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    
                </Paper>
            </div>
        );
    }
    const [alerta, setAlerta] = useState(false);
    const Alert = React.forwardRef(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlerta(false);
    };
    return (
        <Card style={{margin: 20}} className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
            <Loading open={loading} />
            <Card.Header>
                <HeaderBody title={"Faturas"} icon={icon} setShow={setShowFaturas} />
            </Card.Header>
            <Card.Body className='row' style={{paddingTop: 0, paddingBottom: 0}}>
                <div style={{overflow: "auto", height: height}}>
                    {list.map((elemeto, index) => (
                        renderFaturas(elemeto, index)
                    ))}
                    {list.length > 0 && (
                        <div className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" >
                            <CardActions style={{justifyContent: 'space-around'}}>
                                <LoadingButton 
                                variant="secondary" 
                                loading={loadingBt} 
                                onClick={() => loadMore(idContrato)}
                                >
                                    Mostrar mais...
                                </LoadingButton>
                            </CardActions>
                        </div>
                    )}
                </div>
            </Card.Body>
            <Snackbar open={alerta} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="info" sx={{ width: '100%' }}>
                    Copiado para area de transferencia!
                </Alert>
            </Snackbar>
        </Card>
    );
}

export default Faturas;